// Common Angular imports
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Material modules
import { MATERIAL_MODULES, BASIC_MATERIAL_MODULES, FORM_MATERIAL_MODULES, TABLE_MATERIAL_MODULES } from './material.imports';

/**
 * Common Angular modules that are frequently used across components
 */
export const COMMON_MODULES = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
] as const;

/**
 * All commonly used modules (Angular + Material) for most components
 * Use this for components that need full functionality
 */
export const ALL_COMMON_MODULES = [
  ...COMMON_MODULES,
  ...MATERIAL_MODULES,
] as const;

/**
 * Basic modules for simple components
 * Use this for components that only need basic functionality
 */
export const BASIC_MODULES = [
  ...COMMON_MODULES,
  ...BASIC_MATERIAL_MODULES,
] as const;

/**
 * Form-focused modules for form components
 * Use this for components that are primarily forms
 */
export const FORM_MODULES = [
  ...COMMON_MODULES,
  ...FORM_MATERIAL_MODULES,
] as const;

/**
 * Table-focused modules for data display components
 * Use this for components that display data in tables
 */
export const TABLE_MODULES = [
  ...COMMON_MODULES,
  ...TABLE_MATERIAL_MODULES,
] as const;

// Re-export material modules for direct access if needed
export { MATERIAL_MODULES, BASIC_MATERIAL_MODULES, FORM_MATERIAL_MODULES, TABLE_MATERIAL_MODULES } from './material.imports';
